import React from 'react';

/** 櫃台：掃到或查詢「已兌換」優惠券時的紅框提醒 */
export default function CouponUsedNoticeModal({
  open,
  onClose,
  couponName = '',
  displayCode = '',
  usedAt = '',
  width = 420,
}) {
  if (!open) return null;

  return (
    <div
      role="presentation"
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,.45)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
      }}
      onClick={onClose}
    >
      <div
        role="alertdialog"
        aria-labelledby="coupon-used-title"
        style={{
          width: '100%',
          maxWidth: width,
          background: '#fff8f8',
          border: '3px solid #c62828',
          borderRadius: 12,
          boxShadow: '0 10px 32px rgba(198,40,40,.25)',
          padding: '18px 18px 14px',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h3
          id="coupon-used-title"
          style={{ margin: '0 0 14px', fontWeight: 900, fontSize: 22, color: '#b71c1c' }}
        >
          此券已兌換
        </h3>
        {couponName ? (
          <div style={{ marginBottom: 10, fontSize: 16 }}>優惠券：<b>{couponName}</b></div>
        ) : null}
        {displayCode ? (
          <div style={{ marginBottom: 10, fontSize: 16, fontFeatureSettings: '"tnum"' }}>
            兌換編號 {displayCode}
          </div>
        ) : null}
        {usedAt ? (
          <div style={{ marginBottom: 16, fontSize: 14, color: '#555' }}>兌換時間 {usedAt}</div>
        ) : null}
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <button
            type="button"
            onClick={onClose}
            style={{
              padding: '8px 16px',
              fontSize: 16,
              border: '2px solid #c62828',
              borderRadius: 8,
              background: '#fff',
              color: '#c62828',
              fontWeight: 700,
              cursor: 'pointer',
            }}
          >
            關閉
          </button>
        </div>
      </div>
    </div>
  );
}
